import React from 'react';
import Specifications from './Specifications';
import Reviews from './Reviews';
import FrequentlyAskedQuestions from './FrequentlyAskedQuestions';

const About = () => (
  <div className="mb-2 px-5 lg:px-0">
    <div className="overflow-hidden rounded-md border">
      <Specifications />
      <Reviews />
      <FrequentlyAskedQuestions />
    </div>
  </div>
);

export default React.memo(About);
